/**
 * Services module to wrap all 3rd party tracking service objects
 */
export default {
  segment: window.analytics
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/Tracker/Services.js
 **/